import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="logo-small">
        <img class="asha_logo" src="/assest/logo/logo.png" alt="Logo" />
        </div>
        <div className="logo-text">
          ASHA Worker System
          <small>Healthcare Portal</small>
        </div>
      </div>

      <div className="user-profile">
        <div className="avatar">A</div>
        <div className="user-info">
          <div className="name">ASHA Worker</div>
          <div className="role">Health Worker</div>
        </div>
      </div>

      <div className="nav-section">
        <div className="section-title">Main Menu</div>
        <div className="nav-items">
          <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-th-large icon"></i>
            <span>Dashboard</span>
          </NavLink>
          <NavLink to="/beneficiaries-view" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-users icon"></i>
            <span>Beneficiaries</span>
          </NavLink>
        </div>
      </div>

      <div className="nav-section">
        <div className="section-title">Services</div>
        <div className="nav-items">
          <NavLink to="/home-visits" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-home icon"></i>
            <span>Home Visits</span>
          </NavLink>
          <NavLink to="/immunization" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-syringe icon"></i>
            <span>Immunization</span>
          </NavLink>
          <NavLink to="/anc" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-female icon"></i>
            <span>ANC</span>
          </NavLink>
          <NavLink to="/referrals" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-ambulance icon"></i>
            <span>Referrals</span>
          </NavLink>
          <NavLink to="/vhnd" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-calendar-alt icon"></i>
            <span>VHND</span>
          </NavLink>
        </div>
      </div>

      <div className="nav-section">
        <div className="section-title">Reports</div>
        <div className="nav-items">
          <NavLink to="/task-summary" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-chart-bar icon"></i>
            <span>Reports</span>
          </NavLink>
        </div>
      </div>

      <div className="nav-section">
        <div className="section-title">System</div>
        <div className="nav-items">
          <NavLink to="/settings" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-cog icon"></i>
            <span>Settings</span>
          </NavLink>
          <NavLink to="/sync-manager" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-sync icon"></i>
            <span>Sync Manager</span>
            <div className="badge">5</div>
          </NavLink>
          <NavLink to="/help" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <i className="fas fa-question-circle icon"></i>
            <span>Help</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
